import { AuthService } from "./auth.service";


export function authInitializer(authService: AuthService): () => Promise<any> {
  return () => authService.login();
}